<template>
  <div class="page-container">
    <!-- 左侧常见问题 -->
    <div class="sidebar">
      <div class="sidebar-card">
        <div class="sidebar-header">
          <div class="header-icon">
            <i class="el-icon-question"></i>
          </div>
          <div class="header-info">
            <h3>常见问题</h3>
            <p>点击问题快速提问</p>
          </div>
        </div>

        <div class="question-list">
          <div v-for="(item, index) in commonQuestions" :key="index" class="question-item" @click="quickAsk(item.title)">
            <div class="item-icon-box" :style="{ background: item.color }">
              <i :class="item.icon"></i>
            </div>
            <div class="item-text">
              <h4>{{ item.title }}</h4>
              <p>{{ item.desc }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 右侧聊天主区域 -->
    <div class="chat-main">
      <div class="chat-card">
        <!-- 聊天头部 -->
        <div class="chat-header">
          <div class="header-left">
            <div class="bot-avatar-wrapper">
              <img src="/favicons.ico" alt="bot" class="bot-avatar-img" />
            </div>
            <div class="bot-info">
              <div class="title-row">
                <h2>泰山科技大市场智能体</h2>
                <div class="view-count-tag">
                  <i class="el-icon-view"></i>
                  <span>{{ viewCount }} 浏览</span>
                </div>
              </div>
              <p>为您提供专业、智能的科技咨询服务</p>
            </div>
          </div>
          <div class="header-right">
<!--            <span class="status-tag">-->
<!--              <span class="status-dot"></span> 在线服务-->
<!--            </span>-->

            <el-button class="header-btn" type="primary" plain @click="handleNewChat">
              新建对话
            </el-button>

            <el-button
              v-if="!loginTrue"
              class="header-btn"
              type="primary"
              @click="loginUp"
            >
              登录/注册
            </el-button>

            <el-button
              v-else
              class="header-btn"
              type="danger"
              plain
              @click="logout"
            >
              退出
            </el-button>
          </div>
        </div>
        <!-- 聊天消息流 -->
        <div class="chat-body" ref="messagesContainer">
          <template v-if="showMessage.length">
            <div class="date-divider">今天</div>

            <div v-for="(msg, index) in showMessage" :key="index"
                 :class="['message-wrapper', msg.type === 'user' ? 'user-msg' : 'bot-msg']">
              <div class="message-card">
                <div class="msg-header">
                  <div class="msg-user">
                    <i :class="msg.type === 'user' ? 'el-icon-user' : 'el-icon-cpu'"></i>
                    <span class="user-name">{{ msg.type === 'user' ? '我' : '智能助手' }}</span>
                    <span class="msg-time">{{ getCurrentTime() }}</span>
                  </div>
                </div>
                <div class="msg-content" v-html="msg.assistant || msg.question"></div>
              </div>
            </div>
          </template>

          <div v-else class="welcome-empty">
            <img src="/favicons.ico" alt="bot" class="welcome-logo" />
            <div class="welcome-title">欢迎使用科技大市场智能体</div>
            <div class="welcome-sub">请输入您的问题，或点击左侧常见问题快速提问</div>
          </div>
        </div>

        <!-- 底部输入区域 -->
        <div class="chat-footer">
          <div class="input-area">
            <el-input
              v-model="message"
              placeholder="请输入您的问题... (Enter发送)"
              class="custom-input"
              @keydown.native.enter.prevent="handleEnter"
            ></el-input>
            <el-button type="primary" class="send-button-new" @click="send">
              <i class="el-icon-position"></i> 发送
            </el-button>
          </div>
          <div class="footer-tip">
            <i class="el-icon-info"></i> 提示：您也可以点击左侧的常见问题进行快速提问
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { visit } from "@/api/http";

export default {
  data() {
    return {
      loginTrue: false,
      viewCount: 0,
      message: "",
      showMessage: [],
      messageList: [],
      url: "wss://kejichengguo.tskjdsc.com/WebSocketIntelligentAgent/message",
      // url: "ws://localhost:8945/WebSocketIntelligentAgent/message",
      ws: null,
      commonQuestions: [
        { icon: 'el-icon-setting', title: '泰山科技大市场的主要服务有哪些？', desc: '了解我们提供的核心服务和功能', color: 'linear-gradient(135deg, #3B82F6, #06B6D4)' },
        { icon: 'el-icon-refresh', title: '如何进行技术交易或项目对接？', desc: '技术交易流程和项目对接指南', color: 'linear-gradient(135deg, #8B5CF6, #EC4899)' },
        { icon: 'el-icon-document', title: '科技政策咨询与申报支持', desc: '最新科技政策解读和申报指导', color: 'linear-gradient(135deg, #F59E0B, #F97316)' },
        { icon: 'el-icon-coordinate', title: '知识产权保护与交易', desc: '知识产权相关服务与交易流程', color: 'linear-gradient(135deg, #10B981, #34D399)' },
        { icon: 'el-icon-bank-card', title: '科技创新券如何使用？', desc: '科技创新券申请和使用指南', color: 'linear-gradient(135deg, #6366F1, #3B82F6)' },
        { icon: 'el-icon-message', title: '企业技术需求如何发布？', desc: '发布技术需求的方法和步骤', color: 'linear-gradient(135deg, #EF4444, #F97316)' },
        { icon: 'el-icon-data-analysis', title: '科技成果评价与转化', desc: '科技成果评价标准和转化流程', color: 'linear-gradient(135deg, #06B6D4, #22C55E)' },
        { icon: 'el-icon-wallet', title: '科技金融与投融资服务', desc: '科技金融产品与投融资对接', color: 'linear-gradient(135deg, #0EA5E9, #6366F1)' }
      ]
    };
  },
  created() {
    this.checkLogin();
    console.log("copy.vue created - localStorage userId:", localStorage.getItem("userId"));
    console.log("copy.vue created - sessionStorage userId:", sessionStorage.getItem("userId"));
  },
  mounted() {
    this.join();
    this.initViewCount();
  },

  methods: {
    async initViewCount() {
      const pageKey = this.$route?.path || 'intelligent_agent';
      try {
        const res = await visit({ pageKey });
        const data = res && res.data !== undefined ? res.data : res;
        if (data && (data.code === 200 || data.code === 0)) {
          this.viewCount = data.data;
        } else if (typeof data === 'number') {
          this.viewCount = data;
        } else if (data && typeof data.data === 'number') {
          this.viewCount = data.data;
        }
      } catch (e) {
        console.error('浏览量上报失败', e);
      }
    },

    checkLogin() {
      const token = localStorage.getItem('token');
      this.loginTrue = !!token;
    },

    loginUp() {
      this.$router.push({ path: '/login', query: { type: "3" } });
    },
    logout() {
      sessionStorage.clear();
      localStorage.clear();
      this.loginTrue = false;
      this.$router.push({ path: '/login', query: { type: "3" } });
    },
    handleNewChat() {

      window.location.reload();
    },
    getCurrentTime() {
      const now = new Date();
      return `${now.getHours().toString().padStart(2, '0')}:${now.getMinutes().toString().padStart(2, '0')}`;
    },
    quickAsk(text) {
      this.message = text;
      this.send();
    },


    handleEnter(e) {
      if (!e.shiftKey) {
        this.send();
      }
    },
    join() {
      const wsuri = this.url;
      this.ws = new WebSocket(wsuri);
      const self = this;
      this.ws.onmessage = function (event) {
        if (self.showMessage.length !== 0) {

          const cleanData = event.data.replace("end", "").replaceAll("{", "").replaceAll("}", "").replaceAll("\"", "").replaceAll("*","");
          if (self.showMessage[self.showMessage.length - 1].assistant === "正在思考...") {
            self.showMessage[self.showMessage.length - 1].assistant = "";
          }
          self.showMessage[self.showMessage.length - 1].assistant += cleanData;
          self.scrollToBottom();
        }
      };
    },
    send() {
      if (!this.message.trim()) return;
      const token = localStorage.getItem('token');
      if (!token) {
        this.$message.error('请先登录');
        return;
      }

      const question = this.message;
      this.showMessage.push({
        question: question,
        type: "user"
      });
      this.showMessage.push({
        assistant: "正在思考...",
        type: "bot"
      });

      // 获取 userId 并发送到 WebSocket
      // 优先从 localStorage 获取，如果没有则尝试 sessionStorage
      let userId = localStorage.getItem("userId");
      if (!userId) {
        userId = sessionStorage.getItem("userId");
      }
      console.log("发送消息时的 userId:", userId);
      const param = JSON.stringify([{ role: "user", content: question, userId: userId ? Number(userId) : null }]);
      this.ws.send(param);
      this.message = "";
      this.scrollToBottom();
    },
    scrollToBottom() {
      this.$nextTick(() => {
        const container = this.$refs.messagesContainer;
        if (container) {
          container.scrollTop = container.scrollHeight;
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
.page-container {
  display: flex;
  width: 100%;
  height: 100vh;
  background-color: #f0f4f8;
  padding: 20px;
  box-sizing: border-box;
  gap: 20px;
  overflow: hidden;
}

/* 侧边栏样式 */
.sidebar {
  width: 320px;
  flex-shrink: 0;
}

.sidebar-card {
  background: #fff;
  height: 100%;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.05);
  display: flex;
  flex-direction: column;
  padding: 20px;
}

.sidebar-header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding-bottom: 20px;
  border-bottom: 1px solid #eee;
  margin-bottom: 15px;

  .header-icon i {
    font-size: 24px;
    color: #0095ff;
  }
  h3 { margin: 0; font-size: 18px; color: #333; }
  p { margin: 4px 0 0; font-size: 12px; color: #999; }
}

.question-list {
  flex: 1;
  overflow-y: auto;
  padding-right: 5px;

  &::-webkit-scrollbar { width: 4px; }
  &::-webkit-scrollbar-thumb { background: #eee; border-radius: 4px; }
}

.question-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  margin-bottom: 12px;
  cursor: pointer;
  transition: all 0.3s;

  &:hover {
    background: #f0f9ff;
    border-color: #0095ff;
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(0,149,255,0.1);
  }

  .item-icon-box {
    width: 40px;
    height: 40px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
    transition: all 0.3s ease;

    i {
      color: #fff;
      font-size: 20px;
    }
  }

  &:hover {
    background: #f0f9ff;
    border-color: #0095ff;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 149, 255, 0.15);

    .item-icon-box {
      transform: scale(1.1);
      box-shadow: 0 6px 15px rgba(0, 0, 0, 0.15);
    }
  }

  .item-text {
    flex: 1;
    overflow: hidden;

    h4 { margin: 0; font-size: 14px; color: #333; font-weight: 600; }
    p { margin: 4px 0 0; font-size: 12px; color: #999; }
  }
}

/* 聊天区域样式 */
.chat-main {
  flex: 1;
  min-width: 0;
}

.chat-card {
  background: #fff;
  height: 100%;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.05);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border-top: 4px solid #0095ff;
}


.chat-header {
  padding: 15px 25px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #eee;

  .header-left {
    display: flex;
    align-items: center;
    gap: 15px;
  }

  .bot-avatar-wrapper {
    width: 48px;
    height: 48px;
    background: #f0f7ff;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 2px 6px rgba(0,149,255,0.2);

    .bot-avatar-img { width: 32px; height: 32px; }
  }

  .bot-info {
    .title-row {
      display: flex;
      align-items: center;
      gap: 12px;
    }

    h2 { margin: 0; font-size: 20px; color: #0095ff; }

    .view-count-tag {
      background: rgba(0, 149, 255, 0.08);
      color: #0095ff;
      padding: 4px 10px;
      border-radius: 6px;
      font-size: 12px;
      display: flex;
      align-items: center;
      gap: 4px;
      font-weight: 500;
      border: 1px solid rgba(0, 149, 255, 0.15);

      i { font-size: 14px; }
    }

    p { margin: 4px 0 0; font-size: 13px; color: #888; }
  }

  .status-tag {
    background: #f0f9eb;
    color: #67c23a;
    padding: 6px 12px;
    border-radius: 20px;
    font-size: 12px;
    display: flex;
    align-items: center;
    gap: 6px;

    .status-dot {
      width: 8px;
      height: 8px;
      background: #67c23a;
      border-radius: 50%;
    }
  }
}

.chat-body {
  flex: 1;
  padding: 20px;
  overflow-y: auto;
  background-color: #fafbfc;
  display: flex;
  flex-direction: column;

  .date-divider {
    text-align: center;
    color: #ccc;
    font-size: 12px;
    margin: 20px 0;
  }

  .welcome-empty {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding-bottom: 50px;

    .welcome-logo {
      width: 100px;
      height: 100px;
      margin-bottom: 20px;
      opacity: 0.8;
    }

    .welcome-title {
      font-size: 26px;
      color: #333;
      font-weight: 600;
      margin-bottom: 12px;
    }

    .welcome-sub {
      font-size: 16px;
      color: #999;
    }
  }
}

.message-wrapper {
  margin-bottom: 25px;
  display: flex;

  &.bot-msg {
    justify-content: flex-start;
    .message-card {
      border-left: 4px solid #0095ff;
    }
  }

  &.user-msg {
    justify-content: flex-end;
    .message-card {
      background: #f0f7ff;
      border-left: 4px solid #67c23a;
    }
  }
}

.message-card {
  max-width: 85%;
  background: #fff;
  padding: 15px 20px;
  border-radius: 0 12px 12px 12px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.05);

  .msg-header {
    margin-bottom: 10px;
    .msg-user {
      display: flex;
      align-items: center;
      gap: 8px;
      color: #666;
      font-size: 13px;

      i { color: #0095ff; }
      .msg-user-name { font-weight: 600; }
      .msg-time { color: #bbb; margin-left: 10px; }
    }
  }

  .msg-content {
    line-height: 1.6;
    color: #333;
    font-size: 15px;
    word-break: break-all;
    white-space: pre-wrap;
  }
}

.chat-footer {
  padding: 20px 25px;
  border-top: 1px solid #eee;
  margin-top: auto;

  .input-area {
    display: flex;
    gap: 15px;
    align-items: center;
    position: relative;
  }

  .custom-input :deep(.el-input__inner) {
    height: 50px;
    border-radius: 25px;
    padding: 0 25px;
    background: #f5f7fa;
    border: 1px solid #e4e7ed;
    font-size: 15px;

    &:focus {
      border-color: #0095ff;
      background: #fff;
    }
  }

  .send-button-new {
    height: 50px;
    padding: 0 30px;
    border-radius: 25px;
    background: #0095ff;
    font-size: 16px;
    display: flex;
    align-items: center;
    gap: 8px;
    box-shadow: 0 4px 10px rgba(0,149,255,0.3);
    border: none;

    &:hover {
      background: #0081dd;
      transform: translateY(-1px);
    }
  }

  .footer-tip {
    margin-top: 12px;
    color: #999;
    font-size: 12px;
    display: flex;
    align-items: center;
    gap: 5px;
    padding-left: 15px;
  }
}
</style>
